import React from 'react';
import { markSetOpenSource, trackTrackSetClicked } from '../activityTracker';

// CK 3.0: the single "Mark what I own" action, shared by the Set Summary
// sticky bar and the bottom CTA block so behavior cannot drift.
//
// Signed-in → straight into this set's interactive checklist (/sets/<id>).
// Signed-out → the SAME navigation: /sets/<id> renders the sign-in wall
// (sign-up tab for first-time visitors), the path survives the wall, and the
// OAuth redirect returns to it — so the collector lands in this exact
// checklist right after signing in. No auth-page changes involved.
//
// Colors are the same pairing as the page's existing primary CTA
// (cyan fill, page-background text), which is WCAG AA in both themes.
export default function MarkWhatIOwnButton({ setId, user, compact }) {
  const onClick = () => {
    trackTrackSetClicked(user?.id || null, setId, !!user);
    markSetOpenSource(setId, 'set_summary');
    window.history.pushState({}, '', `/sets/${setId}`);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        background: 'var(--cyan)',
        color: 'var(--bg)',
        border: 'none',
        borderRadius: '3px',
        cursor: 'pointer',
        fontFamily: "'Orbitron', monospace",
        fontWeight: 700,
        letterSpacing: '2px',
        fontSize: compact ? '10.5px' : '11px',
        padding: compact ? '15px 18px' : '15px 26px',
        minHeight: '44px',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        boxShadow: '0 0 24px rgba(var(--cyan-rgb),0.3)',
        width: compact ? undefined : '100%',
        boxSizing: 'border-box',
      }}
    >
      MARK WHAT I OWN
    </button>
  );
}
